import React from 'react';
import { connect } from 'react-redux';
import VCardDetails from './components/VCardDetails';
import settings from '../../devices/all/settings';
import {
    getContentData,
    getSeasonId,
    isValidGroupId,
    getGroupIdToRedirect,
    parseContentData,
    getSerieData,
    resolveContentTalent,
    favoriteToggleRequest,
    checkFavoritedContent,
    getBookmark,
    isAnonymousFromProps,
    getGroupIdFromMatchParams,
    getIgnoreSeenLastFromMatchParams,
    getWatchWithBtnBGColor,
} from './fichaHelper';
import {
  contentRecomendations, PurchaseButtonInfov585, UserSeenLast
} from '../../requests/loader';
import {getLastTouch} from "../../requests/utils/utils-last-touch";

import {
    VCARD_MAIN_CLASSNAME,
    PBI_OFFER_SUBSCRIPTION_TYPE,
    VCARD_RESUMEN_MAIN_CLASSNAME,
    PLAY_RIBBON,
    NODE_RIBBONS,
    VCARD_CONTAINER_CLASSNAME,
    VCARD_CLICK,
    CARRUCEL_VCARD,SUPERDESTACADOS, SUPERDESTACADO
} from './Constants';
import { decodeHTML5, setMetricsEvent } from '../../actions/metrics';
import { playFullMedia } from '../../actions/playmedia';
import VCardRecommendations from './components/VCardRecommendations';
import VCardEpisodes from './components/VCardEpisodes';
import VCardTalents from './components/VCardTalents';
import Translator from '../../requests/apa/Translator';
import { LetsPlayCatchup } from '../PersistentMiniEpg/MiniObserver';
import { setLastTouchFavorited, setLastTouchSeen } from '../../reducers/user';
import {
    HIDE_MODAL,
    AAF_MODAL_ERROR,
    MODAL_PIN,
    MODAL_SEASON_SELECTOR,
    MODAL_TALENT_CONTENTS,
} from '../../actions/modal';
import { showNotification } from '../../actions/notification';
import { showModal } from '../../actions/modal';
import {SET_PLAYER_CONTENT_DATA } from '../../actions/playerContentData';
import Asset from '../../requests/apa/Asset';
import Device from '../../devices/device';
import AnalyticsDimensionSingleton from '../Header/AnalyticsDimensionSingleton';
import './_styles.scss';
import Utils, {getContentAvailability, getContentCategory, getSeasonEpisodeInfo} from '../../utils/Utils';
import { MODAL_PIN_CODE_PURCHASE_TYPE } from '../Modal/ModalPinCode';
import LayersControl from '../../utils/LayersControl';
import UtilsPagos from '../../utils/payway/UtilsPagos';
import * as PlanSelectorUtils from '../../payments/PlanSelector/PlanSelectorUtils';
import { adaptPurchaseButtonInfoV2_2 } from '../../requests/adapters/payway/purchaseButtonInfoV2_2.adapter';
import { enablePaymentMethodExperience } from '../../utils/Utils';
import {
    getTransactionalLabels,
    getAndroidTvPolicesLabels,
    getAddonAndroidMessageClassNames,
    getTransactionalPrice,
    getTransactionalTax,
    getTransactionalBonus,
} from '../../payments/utils/Utils';
import {TRANSACTION_COMPONENT_VCARD, CODIGO, PROMOGATE} from '../../payments/utils/constants';
import {shouldMetadataInfoShowed} from 'src/utils/Utils';
import {
    PLAN_SELECTED_BUY,
    PLAN_SELECTED_WHAT_INCLUDED,
    PLAN_SELECTION,
} from '../../packages/components/lib/PlanSelector/constants';
import { sendGAEvent } from '../../utils/analytics';
import store from '../../store';
import { setDataPlay } from '../../actions/modalInactivity';
import PlayerControlsLogic from '../../playerDomain/components/PlayerControlsLogic';
import {
    VCARD_COMPONENT,
    VCARD_VER_TRAILER,
    VCARD_LABEL_AGREGAR_LISTA,
    VCARD_LABEL_QUITAR_LISTA,
    VCARD_QUE_INCLUYE,
    SELECCIONAR_TEMPORADA,
    VCARD_REPRODUCIR,
    VCARD_SUSCRIBETE,
    VCARD_CLARO_VIDEO,
} from './Constants';
import {GA4} from '../../utils/trackers/GA4';
import {CONTENT_SECTION_VCARD, CONTENT_TYPE_SERIE,
        CONTENT_INTERACTION_PLAY, CONTENT_INTERACTION_TRAILER, CONTENT_INTERACTION_ADD_FAVORITE, CONTENT_INTERACTION_DELETE_FAVORITE,
        DOES_NOT_APPLY,CONTENT_TYPE_MOVIE} from '../../utils/trackers/GA4Constants';
import UpdateFavoriteVODObserver from '../../AAFPlayer/helpers/UpdateFavoriteVODObserver';
import { TransactionDetailType } from 'packages/components/lib/TransactionDetail';
import AAF from '../../AAF/AAF';
import { AAF_CONTENT_IS_VOD } from '../../AAFPlayer/constants';
import { setContentDataPublicity } from "../../actions/ads";
import {removeDynamicFocus} from "../Focus/utils";
import DeviceStorage from '../DeviceStorage/DeviceStorage';

const RECOMMENDATION_RIBBON = 'recommendation-ribbon';
const TALENT_RIBBON = 'talent-ribbon';

/* Constantes para el botón "Ver con * en Claro Video ¿Qué incluye este canal?" */
const AAF_FLOW_CALL_CENTER = 'FLOW_CALL_CENTER';
const AAF_FLOW_ADDON = 'AAF_FLOW_ADDON';
const AAF_FLOW_PACKAGE = 'AAF_FLOW_PACKAGE';

class VCard extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            data: null,
            pbi: null,
            serieData: null,
            recommendations: [],
            roles: [],
            externalrole: null,
            ribbonOrder: [RECOMMENDATION_RIBBON, TALENT_RIBBON],
            dataEpisodes: '',
        };
        this.keys = Device.getDevice().getKeys();
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleUpdateProgress = this.handleUpdateProgress.bind(this);
        this.handlePlayClick = this.handlePlayClick.bind(this);
        this.handleTrailerClick = this.handleTrailerClick.bind(this);
        this.handleFavoriteClick = this.handleFavoriteClick.bind(this);
        this.handleUnFavoriteClick = this.handleUnFavoriteClick.bind(this);
        this.handlePurchaseClick = this.handlePurchaseClick.bind(this);
        this.handleWathWithDetailsClick = this.handleWathWithDetailsClick.bind(this);
        this.handleSelectSeason = this.handleSelectSeason.bind(this);
        this.pushContent = this.pushContent.bind(this);
        this.handleEpisodeClick = this.handleEpisodeClick.bind(this);
        this.handleTalentClick = this.handleTalentClick.bind(this);
        this.changeContent = this.changeContent.bind(this);
        this.tooglePlay = false;
        this.recommendationsRef = null;
        this.handleFocusEpisodes = this.handleFocusEpisodes.bind(this);
        this.cleanDataEpisodes = this.cleanDataEpisodes.bind(this);
        this.shouldShowAndroidMessage = this.shouldShowAndroidMessage.bind(this);
        this.handleFavoriteUpdateFromPlayer = this.handleFavoriteUpdateFromPlayer.bind(this);
        this.getTransactionTypeLabel = this.getTransactionTypeLabel.bind(this);
        /* Métodos para el botón "Ver con * en Claro Video ¿Qué incluye este canal?" */
        this.getTypeOffer = this.getTypeOffer.bind(this);
        this.getQuantityVisibleParam = this.getQuantityVisibleParam.bind(this);
        this.getOfferId = this.getOfferId.bind(this);
        this.getFirstPlan = this.getFirstPlan.bind(this);
        this.getVisiblePlan = this.getVisiblePlan.bind(this);
        this.sendGA4Metric = this.sendGA4Metric.bind(this);
        this.interactionType = '';

        /**
         * Mapa extensible de handlers de métricas GA4 (Patrón Strategy)
         * Permite agregar nuevos tipos de métricas sin modificar sendGA4Metric
         * Open/Closed Principle: abierto a extensión, cerrado a modificación
         */
        this.ga4MetricHandlers = {
            'D13': this.handleD13Metric.bind(this),
            'E1': this.handleE1Metric.bind(this),
            'E2': this.handleE2Metric.bind(this),
            'E4-E7': this.handleE4E7Metric.bind(this),
            'E5': this.handleE5Metric.bind(this),
        };

    }

    /* Metricas */
    sendMetric(action, label = null) {
        const { setMetricsEvent = () => {} } = this.props;
        const { data: { title = '', episode } = {} } = this.state;
        if (action === 'cambiar episodio') {
            const seasonNumber = this.getSeasonNumber(episode.season);
            label = `${title} - ${seasonNumber} - ${episode.name}`;
        } else {
            if (label !== null) label = `${label} - ${title}`;
            else label = `${title}`;
        }
        setMetricsEvent({
            hitType: 'event',
            eventCategory: 'vcard',
            eventAction: action,
            eventLabel: label,
        });
        setMetricsEvent({ type: 'executor' });
        this.sendDimension();
    }

    getSeasonNumber(season) {
        const {
            serieData: { seasons },
        } = this.state;
        const serilNumber = seasons[season - 1].title.split('-');
        return serilNumber[1].trim();
    }

    sendDimension() {
        const { setMetricsEvent = () => {} } = this.props;
        setMetricsEvent(new AnalyticsDimensionSingleton().getPayload());
        setMetricsEvent({ type: 'executor' });
    }

    sendVirtualPage(types, genreArray, title) {
        const { from } = store.getState().navbar;
        const { setMetricsEvent = () => {} } = this.props;
        const dataMetrics = {
            hitType: 'event',
            eventCategory: from.node_initial
                ? `carruseles ${from.node_initial.toLowerCase()}`
                : `carruseles `,
            eventAction: from.ribbon_title ? from.ribbon_title.toLowerCase() : '',
            eventLabel: title ? title.toLowerCase() : '',
        };

        setMetricsEvent(dataMetrics);
        setMetricsEvent({ type: 'executor' });
    }

    sendYoubora(purchaseButtonInfo) {
        // Youbora: Se setea el parametro window.youboraParams[5] cuando paymentmethod en linealChannels viene null
        if (
            window.youboraParams[5].value !== null &&
            purchaseButtonInfo.playButton &&
            purchaseButtonInfo.playButton &&
            purchaseButtonInfo.playButton.paymentmethod &&
            purchaseButtonInfo.playButton.paymentmethod.gateway
        ) {
            window.youboraParams[5].value = purchaseButtonInfo.playButton.paymentmethod.gateway;
        }
        // Youbora: Se setea el Tipo de abono para youboraParams[2] cuando el tipo de contenido es VOD en caso de que sea trailer no manda el parametro
        if (purchaseButtonInfo.playButton)
            window.youboraParams[2].value = purchaseButtonInfo.playButton.key;
    }

    /* Funciones locales */

    goBack() {
        const { history } = this.props;
        history.goBack();
        // setTimeout(() => {
        // if (window.location.href.indexOf('/vcard') !== -1) {
        //     const pathname = window.location.pathname.split('/');
        //     const goGroupIdBack = pathname[2] ? pathname[2] : '';
        //     this.replaceContent(goGroupIdBack);
        // }
        // }, 100);
    }

    setLenguageData(contentData) {
        if (
            contentData &&
            contentData.group &&
            contentData.group.common &&
            contentData.group.common.extendedcommon &&
            contentData.group.common.extendedcommon.media &&
            contentData.group.common.extendedcommon.media.language &&
            contentData.group.common.extendedcommon.media.language.options &&
            contentData.group.common.extendedcommon.media.language.options.option
        ) {
            this.lenguageData =
                contentData.group.common.extendedcommon.media.language.options.option;
        }
    }

    async getFavoritedAndBookmark(groupId) {
        const { user } = this.props;
        const { lastTouchSeen } = this.state;
        let favorited = false,
            bookmark = null;
        try {
            const [favoritedResolved, bookmarkResolved] = await Promise.all([
                checkFavoritedContent(groupId, user),
                getBookmark(groupId, isAnonymousFromProps(this.props), lastTouchSeen),
            ]);
            favorited = favoritedResolved;
            bookmark = bookmarkResolved;
        } catch (e) {}
        return new Promise((resolve) => resolve({ favorited, bookmark }));
    }

    handleFavoriteUpdateFromPlayer(favorite) {
        const { data: { title = '', groupId = '' } = {} } = this.state;
        if(favorite.groupId === groupId) {
            this.setState(
                (prevState) => ({
                    data: { ...prevState.data,
                            isFavorite: favorite.isFavorite
                        },
                })
            );
        }
    }

    sendToPlay(hasTrailer = false) {
        this.tooglePlay = !this.tooglePlay;
        const { playFullMedia = () => {} } = this.props;
        const {
            data: { groupId, seasonId = null } = {},
            pbi: { playButton: { payway_token = null } = {} } = {},
            recommendations,
        } = this.state;

        const { publicity = "false", rolls = {}} = store.getState().ads || {};

        if (isValidGroupId(groupId)) {
          const contentData = this.getItemData();
          store.dispatch({
            contentData,
            type: SET_PLAYER_CONTENT_DATA,
          });
            playFullMedia({
                publicity,
                rolls,
                payway_token,
                playerstate: 'PLAYING',
                source: {
                    videoid: groupId,
                    seasonid: seasonId,
                },
                size: {
                    top: 0,
                    left: 0,
                    width: 1280,
                    height: 720,
                },
                ispreview: hasTrailer,
                islive: false,
                ispip: false,
                recommendations: recommendations,
                tooglePlay: this.tooglePlay,
                event: null,
                languageoptions: this.lenguageData,
            });
        }
    }

    favoriteToggle(isFavorite = false, idElement = "") {
        const { data: { title = '', groupId = '' } = {} } = this.state;
        const {
            user: { session_userhash = '' } = {},
            setLastTouchSeen = () => {},
            setLastTouchFavorited = () => {},
            showNotification = () => {},
            showModal = () => {},
        } = this.props;
        const params = {
            object_id: groupId,
            object_type: 1,
            user_hash: session_userhash,
            live: false,
        };
        favoriteToggleRequest(
            params,
            isFavorite,
            (data) => {
                const responseData = data.data;
                Utils.sendMetric(
                    this.props,
                    !isFavorite ? VCARD_LABEL_AGREGAR_LISTA : VCARD_LABEL_QUITAR_LISTA,
                    title.toLowerCase(),
                    VCARD_COMPONENT
                );
                // Actualizar favoritos y seen con el mismo valor de favorited
                if (responseData.lasttouch && responseData.lasttouch.favorited) {
                    const lastTouchFav = responseData.lasttouch.favorited;
                    setLastTouchSeen(lastTouchFav);
                    setLastTouchFavorited(lastTouchFav);
                }
                // this.props.updateFavorite(this.favoriteData);
                if (responseData && (responseData.delete || responseData.add)) {
                    this.setState(
                        (prevState) => ({
                            data: { ...prevState.data, isFavorite: !isFavorite },
                        }),
                        () => this.focusOnElementoPredeterminado(`#${idElement}`)
                    );
                }
            },
            (e) => {
                const modal = {
                    modalType: AAF_MODAL_ERROR,
                    modalProps: {
                        content: e,
                    },
                };
                showModal(modal);
            }
        );
    }

    goToPayment(currentPin = null, btn) {
        const { history } = this.props;
        const { pbi, data: {title, groupId, providerName} = {} } = this.state;
        if (currentPin) {
            btn.accessCode = pbi.accessCode;
            btn.accessCodePin = currentPin;
        }
        const redirect = (btn.price !== '' || !btn.isPromoCode) ? '/detailtransaction' : '/payment-promogate';
        history.push(redirect, {
            itemData: this.getItemData(),
            groupId: this.groupId,
            ...btn,
            hideTextStep: true,
            metricsHistory: history.location.pathname,
            trial: '',
            forceReset: false,
        });
    }

    /* Manejo de eventos */
    addListener() {
        document.removeEventListener('keydown', this.handleKeyPress, true);
        document.addEventListener('keydown', this.handleKeyPress, true);
        document.removeEventListener(settings.update_progress, this.handleUpdateProgress);
        document.addEventListener(settings.update_progress, this.handleUpdateProgress);
        UpdateFavoriteVODObserver.on('favorite', this.handleFavoriteUpdateFromPlayer);
    }

    removeListener() {
        document.removeEventListener('keydown', this.handleKeyPress, true);
        document.removeEventListener(settings.update_progress, this.handleUpdateProgress);
        UpdateFavoriteVODObserver.removeListener("favorite", this.handleFavoriteUpdateFromPlayer);
    }

    handleKeyPress(e) {
        if (LayersControl.isPlayerVisible()) {
            return;
        }
        if (!Utils.isModalHide()) {
            return;
        }
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case 'BACK':
                this.goBack();
                break;
            default:
        }
    }

    handleUpdateProgress(e) {
        const { detail: { videoid: groupId = null } = {} } = e;
        const { lastTouchSeen } = this.state;

      if (groupId) {
            getBookmark(groupId, isAnonymousFromProps(this.props), lastTouchSeen).then(({ progress }) => {
                this.setState((prevState) => ({ data: { ...prevState.data, progress } }));
            });
        }
    }

    handlePlayClick() {
        PlayerControlsLogic.setValueStatePlaying({
          controlTime: new Date().getTime()
        })
        LetsPlayCatchup.fire();
        const { from, nodes } = store.getState().navbar;
        if (nodes && nodes.length > 0 && from && from.node_location && from.node_location !== '') {
            const node = nodes.find((node) => from.node_location.includes(node.code));
            if (node && node.text && node.text !== '') {
                sendGAEvent({
                    hitType: 'event',
                    eventCategory: decodeHTML5(NODE_RIBBONS.replace('{{NODE_NAME}}', node.text)),
                    eventAction: decodeHTML5(
                        PLAY_RIBBON.replace('{{RIBBON_NAME}}', from.ribbon_title)
                    ),
                    eventLabel: decodeHTML5(from.card_element.title),
                });
            }
        }
        this.sendMetric(VCARD_REPRODUCIR);
        this.interactionType = CONTENT_INTERACTION_PLAY;
        this.sendGA4Metric('E2');
        this.sendToPlay();
    }

    handleTrailerClick() {
        LetsPlayCatchup.fire();
        this.interactionType = CONTENT_INTERACTION_TRAILER;
        this.sendGA4Metric('E2');
        this.sendToPlay(true);
        this.sendMetric(VCARD_VER_TRAILER);
    }

    setFavoriteToggle(idElement) {
        this.interactionType = CONTENT_INTERACTION_ADD_FAVORITE;
        this.sendGA4Metric('E2');
        this.favoriteToggle(false, idElement);
    }

    handleFavoriteClick(e) {
        e.preventDefault();
        const idElement = e.target.id;
        if (AAF.AdsUtils.isAdsEnable()) {
            const userType = AAF.AdsUtils.getUserType();
            const isFreemium = AAF.AdsUtils.isUserFreemium(userType);
            if (!isFreemium) {
                this.setFavoriteToggle(idElement);
            } else {
                AAF.AdsUtils.redirectToLogin(
                    this.props.history,
                );
            }
        } else {
            this.setFavoriteToggle(idElement);
        }
    }

    handleUnFavoriteClick(e) {
        e.preventDefault();
        const idElement = e.target.id;
        this.interactionType = CONTENT_INTERACTION_DELETE_FAVORITE;
        this.sendGA4Metric('E2');
        this.favoriteToggle(true, idElement);
    }

    handlePurchaseClick(e, button, providerName) {
        e.preventDefault();
        const { history, showModal = () => {} } = this.props;
        const { pbi, data } = this.state;
        const { from, nodes } = store.getState().navbar;
        const { oneofferdesckey } = button;
        let offerDesc = '';
        this.sendGA4Metric('E4-E7', button);
        if (button.family === VCARD_CLARO_VIDEO) {
            offerDesc = Translator.get(oneofferdesckey, '').split(' ');
            Utils.sendMetric(
                this.props,
                VCARD_SUSCRIBETE,
                offerDesc.length > 1 ? offerDesc[1].toLowerCase() : offerDesc[0].toLowerCase(),
                VCARD_COMPONENT
            );
        } else {
            Utils.sendMetric(this.props, VCARD_SUSCRIBETE, data.title, VCARD_COMPONENT);
        }

        if (nodes && nodes.length > 0 && from && from.node_location && from.node_location !== '') {
            const node = nodes.find((node) => from.node_location.includes(node.code));
            if (node && node.text && node.text !== '') {
                sendGAEvent({
                    hitType: 'event',
                    eventCategory: decodeHTML5(NODE_RIBBONS.replace('{{NODE_NAME}}', node.text)),
                    eventAction: decodeHTML5(PLAN_SELECTION),
                    eventLabel: decodeHTML5(
                        PLAN_SELECTED_BUY.replace('{{PLAN_SELECTED}}', providerName)
                    ),
                });
            }
        }
      //  pbi.accessCode = null; //Quitar, solo se ocupa para forzar a que se vaya a checkiut
        if (pbi && pbi.accessCode && pbi.accessCode.enabled) {
            const modal = {
                modalType: MODAL_PIN,
                modalProps: {
                    type: MODAL_PIN_CODE_PURCHASE_TYPE,
                    action: 'MP_CHECAR_STATUS',
                    pinIsCreated: true,
                    successCallBack: (currentPin, pinIsCreated) => {
                        this.goToPayment(currentPin, button);
                    },
                    flag: true,
                },
            };
            showModal(modal);
        } else {
            this.goToPayment(null, button);
        }
    }

    /* Métodos para el botón "Ver con * en Claro Video ¿Qué incluye este canal?" */
    getQuantityVisibleParam(buttons) {
        let result = 0;
        if (buttons && Array.isArray(buttons)) {
            const findVisibles = buttons.filter((obj) => {
                if (obj.hasOwnProperty('purchasable')) {
                    return obj.purchasable === true;
                } else {
                    return false;
                }
            });
            if (findVisibles && Array.isArray(findVisibles)) {
                result = findVisibles.length;
            }
        }
        return result;
    }

    getTypeOffer(pbi) {
        const { listButtons: { button = [] } = {} } = pbi || {};
        const quantity = this.getQuantityVisibleParam(button);
        if (quantity === 1) {
            return AAF_FLOW_ADDON;
        } else if (quantity > 1) {
            return AAF_FLOW_PACKAGE;
        } else {
            return AAF_FLOW_CALL_CENTER;
        }
    }

    getOfferId(pbi) {
        const { listButtons: { button: [firstButton = {}] = [] } = {} } = pbi || {};
        const { offerid } = firstButton || {};
        return offerid;
    }

    getFirstPlan(pbi) {
        const { listButtons: { button: [firstPlan = {}] = [] } = {} } = pbi || {};
        return firstPlan;
    }

    getVisiblePlan(pbi, userLoggedIn = false) {
        let visiblePlan = {};
        const { listButtons: { button = [] } = {} } = pbi || {};
        if (Array.isArray(button)) {
            const firstButtonArray = button.filter((obj) => {
                if (obj.hasOwnProperty('visible')) {
                    return obj.visible === true;
                } else {
                    return true;
                }
            });
            visiblePlan = firstButtonArray[0] || {};
            if (Object.keys(visiblePlan).length > 0) {
                visiblePlan.fromsusctv = userLoggedIn ? 'susctvregistrado' : 'susctvanonimo'; // Para back desde payment
            }
        }
        return visiblePlan;
    }

    async getPlans() {
        try {
          const res = await PlanSelectorUtils.getPlans({ object_type: 'A' });
          const pbiRes = enablePaymentMethodExperience() ? adaptPurchaseButtonInfoV2_2(res) : res;
          const response = pbiRes.response;
          return response;
        } catch (err) {
          console.error('Error al obtener la pbi:', err);
        }
      }

      filterButtonsByFamily(pbi, family) {
        if (pbi) {
            const { listButtons: { button = [] } = {} } = pbi || {};
          const filteredButtons = button.filter(button => button.family === family);
          pbi.listButtons.button = filteredButtons;
          return pbi;
        } else {
          return pbi;
        }
      }


    async handleWathWithDetailsClick(e,family) {
        e.preventDefault();
        let pbi =  await this.getPlans();
        pbi = this.filterButtonsByFamily(pbi, family);
        const { history, history: { location: { pathname = ''} } } = this.props;
        const { user } = this.props;
        const userLoggedIn = user.isAnonymous === false;
        const typeFlow = this.getTypeOffer(pbi);
        const offerid = this.getOfferId(pbi);
        const plan =
            typeFlow === AAF_FLOW_CALL_CENTER
                ? this.getFirstPlan(pbi)
                : this.getVisiblePlan(pbi, userLoggedIn);
        const labels = getTransactionalLabels();
        const { listButtons: { button = [] } = {} } = pbi || {};
        const details = button ? PlanSelectorUtils.parseDetailPlan(button, labels) : [];
        const detail = details.find((detail) => detail.id === offerid);
        const activePlan = { ...PlanSelectorUtils.parsePlan(plan, null, labels), ...detail };
        const provider = '';
        Utils.sendMetric(this.props, VCARD_QUE_INCLUYE, activePlan.provider, VCARD_COMPONENT);
        this.sendGA4Metric('E4-E7', activePlan);
        const urlFlowType = pathname || '';
        history.push(`/detailSelector`, { activePlan, provider, vcardData: {
            itemData: this.getItemData(),
            groupId: this.groupId,
            hideTextStep: true,
            metricsHistory: pathname,
            trial: ''
        },
        urlFlowType
    });
    }

    handleSelectSeason() {
        const { serieData, data } = this.state;
        const { title: serieTitle = '' } = data;
        const { showModal = () => {}, user = {} } = this.props;
        Utils.sendMetric(this.props, SELECCIONAR_TEMPORADA, data.title, VCARD_COMPONENT);
        const modal = {
            modalType: MODAL_SEASON_SELECTOR,
            modalProps: {
                serieTitle,
                serieData,
                user,
                changeContent: this.changeContent,
            },
        };
        this.cleanDataEpisodes();
        showModal(modal);
    }

    handleTalentClick(talent) {
        const { showModal = () => {}, setMetricsEvent = () => {}, user } = this.props;
        const { provider_id = '' } = this.state;
        const handleCardClick = (gid) => {
            this.pushContent(gid);
        };
        Utils.sendMetric(this.props, VCARD_CLICK, talent.fullname, VCARD_COMPONENT);
        const modal = {
            modalType: MODAL_TALENT_CONTENTS,
            modalProps: {
                talent,
                providerIdFromVCard: provider_id,
                setMetricsEvent,
                user,
                handleCardClick,
            },
        };
        showModal(modal);
    }

    handleEpisodeClick({ id: groupId = null, title_episode = '' }) {
        if (groupId) {
            this.sendMetric('click', title_episode);
            this.sendGA4Metric('D13');
            this.changeContent(groupId);
        }
    }

    getItemData(){
        const {
            data : {genders, title, episode = {}, groupId, isLive, isSerie, types, providerName} = {},
            dataEpisodes : {id, title:  episodeTitle, provider, format_types} = {},
            pbi = {},
        } = this.state || {};
        const {playButton} = pbi || {}
        const {producttype} = playButton || {}
        const isEpisode = episode && episode.number !==undefined;
        return {
            item_name: title,
            item_id: groupId,
            item_brand: providerName,
            item_category: getContentCategory(isLive, isSerie, genders),
            item_category2: genders && Array.isArray(genders) ? genders.join(' '): DOES_NOT_APPLY,
            item_category3:  getContentAvailability(types, provider, isSerie, isEpisode, producttype),
            item_category4: getSeasonEpisodeInfo(isSerie, isEpisode, episode),
            content_list:  `temporada ${episode && episode.season? episode.season : ''}`
        }
    }

    /**
     * Obtiene la sección activa del menú principal desde el DOM
     * 
     * NOTA: Accede a `document` directamente porque:
     * - La información del menú activo no está disponible en props/state de VCard
     * - Es requerido por GA4 para el campo content_section de métricas
     * - Alternativa (Context API) no disponible en React 15.x
     */
    getContentSection(){
        const activeElement = document.querySelector('a.menu-item.active');
        const textMenu = activeElement ? activeElement.textContent.trim() : '';
        return textMenu;
    }

    /**
     * Despacha métricas GA4 según ID de evento usando mapa de handlers (Strategy Pattern)
     * 
     * @param {string} ID - Identificador del evento (D13, E1, E2, E4-E7, E5, etc.)
     * @param {object} selectedButton - Botón seleccionado (opcional, para E4-E7)
     * @param {string} dataRibbon - Ribbon de origen (opcional, para E1)
     * 
     * EXTENSIBILIDAD: Para agregar un nuevo tipo de métrica:
     * 1. Crear método handleXXXMetric(context) con la lógica específica
     * 2. Agregarlo a this.ga4MetricHandlers en el constructor
     * 3. NO es necesario modificar este método ✅
     */
    sendGA4Metric(ID, selectedButton, dataRibbon){
        const gA4 = new GA4();
        const {
            data : {genders, title, episode = {}, groupId, isLive, isSerie, types, providerName} = {},
            dataEpisodes : {id, title:  episodeTitle, provider, format_types} = {},
            pbi = {},
        } = this.state || {};
        const {listButtons : {button = []}= {}, playButton} = pbi || {}
        const {producttype} = playButton || {}
        const isEpisode = episode && episode.number !==undefined;
        const name = title;

        // Contexto compartido por todos los handlers
        const context = {
            gA4,
            genders,
            title,
            episode,
            groupId,
            isLive,
            isSerie,
            types,
            providerName,
            id,
            episodeTitle,
            provider,
            format_types,
            button,
            producttype,
            isEpisode,
            name,
            selectedButton,
            dataRibbon,
        };

        // Despacho mediante mapa de handlers (extensible sin modificar esta función)
        const handler = this.ga4MetricHandlers[ID];
        if (handler) {
            handler(context);
        } else {
            console.warn(`[VCard] sendGA4Metric: Handler no encontrado para ID='${ID}'`);
        }
    }

    /**
     * Handler para métrica D13: Selección de contenido de serie
     */
    handleD13Metric(context) {
        const { gA4, episode, genders, id, name, isSerie, isEpisode, episodeTitle, provider, format_types, producttype } = context;
        const list = `temporada ${episode && episode.season? episode.season : ''}`;
        const category = genders && Array.isArray(genders) ? genders.join(' '): '';
        const type = CONTENT_TYPE_SERIE;
        const availability = getContentAvailability(format_types, provider, isSerie, isEpisode, producttype);
        gA4.sendSelectContentSerieEvent(CONTENT_SECTION_VCARD, list, id, name, type, category, availability, `episodio ${episodeTitle}`);
    }

    /**
     * Handler para métrica E1: Detalle de contenido
     */
    handleE1Metric(context) {
        const { gA4, groupId, name, genders, types, provider, isSerie, isEpisode, episode, providerName, button, producttype, isLive, dataRibbon, title } = context;
        this.sendContentDetailMetric(gA4, {
            groupId, name, genders, types, provider, isSerie, isEpisode, 
            episode, providerName, button, producttype, isLive, dataRibbon, title
        });
    }

    /**
     * Handler para métrica E2: Interacción con contenido
     */
    handleE2Metric(context) {
        const { gA4, isLive, isSerie, genders, groupId, name, types, provider, isEpisode, producttype } = context;
        const contentType = getContentCategory(isLive, isSerie, genders);
        const category = genders && Array.isArray(genders) ? genders.join(' '): '';
        const availabilityE2 = getContentAvailability(types, provider, isSerie, isEpisode, producttype);
        gA4.sendInteractContentEvent(this.interactionType, CONTENT_SECTION_VCARD, groupId, name, contentType, category, availabilityE2);
    }

    /**
     * Handler para métrica E4-E7: Inicio de checkout
     */
    handleE4E7Metric(context) {
        const { gA4, groupId, name, genders, types, provider, isSerie, isEpisode, episode, providerName, button, selectedButton, producttype, isLive } = context;
        this.sendStartCheckoutMetric(gA4, {
            groupId, name, genders, types, provider, isSerie, isEpisode,
            episode, providerName, button, selectedButton, producttype, isLive
        });
    }

    /**
     * Handler para métrica E5: Placeholder para implementación futura
     */
    handleE5Metric(context) {
        console.warn('[VCard] handleE5Metric: Implementación pendiente');
    }

    sendContentDetailMetric(gA4, params) {
        const {
            groupId, name, genders, types, provider, isSerie, isEpisode,
            episode, providerName, button, producttype, isLive, dataRibbon, title
        } = params;

        const category = getContentCategory(isLive, isSerie, genders);
        const category2 = genders && Array.isArray(genders) ? genders.join(' ') : '';
        const category3 = getContentAvailability(types, provider, isSerie, isEpisode, producttype);
        const category4 = getSeasonEpisodeInfo(isSerie, isEpisode, episode);
        
        const firstOffer = button.find((b) => b.waspurchased === '0' && b.purchasable);
        const price = firstOffer ? firstOffer.price : '0.00';

        // Caso especial: series en carrusel superdestacado
        if (this.isFromSuperDestacadoCarousel(isSerie, dataRibbon)) {
            const priceOffer = button.find((b) => b.waspurchased === '0' && b.purchasable);
            this.sendMetricsSDSeries(
                groupId, isSerie, category2, category3, isEpisode,
                priceOffer, episode, providerName, dataRibbon, title
            );
        } else {
            // Caso normal: envío estándar de métricas de detalle
            gA4.sendContentDetailEvent(
                groupId, name, category, category2, category3, category4,
                providerName, CONTENT_SECTION_VCARD, price, 1
            );
        }
    }

    sendStartCheckoutMetric(gA4, params) {
        const {
            groupId, name, genders, types, provider, isSerie, isEpisode,
            episode, providerName, button, selectedButton, producttype, isLive
        } = params;

        const category = getContentCategory(isLive, isSerie, genders);
        const category2 = genders && Array.isArray(genders) ? genders.join(' ') : '';
        const category4 = getSeasonEpisodeInfo(isSerie, isEpisode, episode);
        
        const firstOffer = button.find((b) => b.waspurchased === '0' && b.purchasable);
        const price = firstOffer ? firstOffer.price : '0.00';

        const {price: selectedButtonPrice = false, producttype: producttype2} = selectedButton || {};
        const contentAvailability = getContentAvailability(types, provider, isSerie, isEpisode, producttype2);
        
        gA4.sendStartCheckoutEvent(
            groupId, name, category, category2, contentAvailability, category4,
            providerName, CONTENT_SECTION_VCARD, selectedButtonPrice ? selectedButtonPrice : price, 1
        );
    }

    isFromSuperDestacadoCarousel(isSerie, dataRibbon) {
        if (!isSerie || !dataRibbon) return false;
        const ribbonLower = dataRibbon.toLowerCase();
        return ribbonLower === SUPERDESTACADO || ribbonLower === `${SUPERDESTACADOS}`;
    }

    /**
     * Envía métricas GA4 para series del carrusel superdestacado (STVCL-1147)
     * 
     * NOTA: Instancia GA4 y accede a DeviceStorage directamente. Esto es aceptable porque:
     * - GA4 es una utilidad de infraestructura global (no lógica de negocio)
     * - DeviceStorage es un singleton del framework (wrapper de LocalStorage)
     * - El payload está tipado explícitamente (ISelectContentEventSDSeriesPayload)
     * - Inyección de dependencias tendría costo desproporcionado en React 15.x
     */
    sendMetricsSDSeries(groupId, isSerie, category2, category3, isEpisode, price, episode, providerName, dataRibbon, title){
        const gA4 = new GA4();
        // Obtener sección activa desde el DOM (no disponible en props/state)
        const content_section = this.getContentSection().toLowerCase();
        const content_id = groupId;
        const content_type = isSerie ? CONTENT_TYPE_SERIE : CONTENT_TYPE_MOVIE;
        const content_category = category2.toLowerCase();
        const content_availability = category3.toLowerCase();
        const content_episode = isEpisode ? `episodio ${episode.number}` : null;
        const content_price = price && price.price ? price.price : '0.00';
        const content_season = episode && episode.season ? `temporada ${episode.season}`  : null;
        const providerN = providerName.toLowerCase();
        const content_position = DeviceStorage.getItem('position_card_superdestacados_selected') || undefined;;
        // Limpiar la clave inmediatamente después de leerla para evitar persistencia no deseada (STVCL-1147)
        DeviceStorage.unsetItem('position_card_superdestacados_selected');
        const content_list = dataRibbon.toLowerCase()
        const content_name = title.toLowerCase();
        const dataMetrics = Utils.getDataContentSDSeries(content_section,content_id, content_type, content_category, 
                                                         content_availability, content_episode,content_price, content_season,
                                                         providerN, content_position, content_list, content_name);
        gA4.sendSelectContentEventSDSeries(dataMetrics);
    }

    //? Función para limpiar la data de Episodios y la metadata de vcard se visualice al inicio
    cleanDataEpisodes() {
        this.setState({ dataEpisodes: '' });
    }

    //? Handle para saber en que episodio se encuentra el focus
    handleFocusEpisodes(data) {
        this.setState({ dataEpisodes: data });
    }

    /* Manejo de la actualización de la UX */
    clearPBIandRecommendations() {
        this.setState({
            isLoading: true,
            data: null,
            pbi: null,
            serieData: null,
            recommendations: [],
            roles: [],
            externalrole: null,
        });
    }

    loadPurchaseButtonInfoAsync(groupId, data = {}, dataRibbon) {
        const params = { groupId };
        if (data.seasonId) {
            params.seasonId = data.seasonId;
        }

        PurchaseButtonInfov585(params)
            .then((pbi) => {

                removeDynamicFocus();
                this.sendYoubora(pbi)
                this.setState(
                    {
                      pbi,
                    },
                  ()=>{
                  //se agrega un delay para cuestión de foco dinámico cuando existe bookmark
                  setTimeout(()=>{
                    this.focusOnElementoPredeterminado()
                  }, 500)
                  }
                );
                this.sendGA4Metric('E1', "", dataRibbon);
            })
            .catch((err) => {
              //se agrega un delay para cuestión de foco dinámico cuando existe bookmark
              setTimeout(()=>{
                this.focusOnElementoPredeterminado()
              }, 1000)
                console.log('[VCard] loadPurchaseButtonInfoAsync catch err', err);
            });
    }

    async loadBookMarkAndFavoritedAsync(groupId) {
        const { favorited, bookmark } = await this.getFavoritedAndBookmark(groupId);
        const { progress = 0 } = bookmark || {};
        this.setState((prevState) => {
            let newData = {};
            removeDynamicFocus();
            this.focusOnElementoPredeterminado()
            if (prevState.data) {
                newData = { ...prevState.data };
            }
            return {
                data: {
                    ...newData,
                    progress,
                    isFavorite: !!favorited,
                },
            };
        });
        if (AAF.AdsUtils.isAfterLogin()) {
            if (!favorited) {
                this.setFavoriteToggle();
                AAF.AdsUtils.resetStateAfterLogin();
            } else {
                AAF.AdsUtils.resetStateAfterLogin();
            }
        }
    }

    getKeyWords(contentData) {
        const {
            group: {
                common: {
                    extendedcommon: { keywords = {} } = {},
                } = {},
            } = {},
        } = contentData || {};
        const { keyword: keyWordsArray = [] } = keywords || {};
        return keyWordsArray;
    }

    loadRecommendationsAsync(groupId, contentData) {
        const {user} = store.getState() || {};
        const restictiveKewords = ['55002', '102004', '56003'];
        const keyWordsKids = this.getKeyWords(contentData);
        const hasRestrictiveKeyword = restictiveKewords.some(keyword => keyWordsKids.includes(keyword));
        let  isKids = user && user.is_kids;
        isKids = isKids === undefined || isKids === 'false' ? false : true;
        const showRecommendations = hasRestrictiveKeyword && isKids ? false : true;
        
        contentRecomendations({ groupId, is_only_provider: true }, showRecommendations)
            .then((recommendations) => {
                if (Array.isArray(recommendations) && recommendations.length > 0) {
                    this.setState({
                        recommendations,
                    });
                }
            })
            .catch((err) => {
                console.log('[VCard] loadRecommendationsAsync catch err', err);
            });
    }

    asyncLoadSerieContent(contentData) {
        getSerieData(contentData)
            .then(({ serieData }) => {
                const { episodeNumber = -1 } = serieData || {};
                this.setState({ serieData });
            })
            .catch((err) => {
                console.log('[VCard] asyncLoadSerieContent catch err', err);
            });
    }

    loadTalents(contentData) {
        const { roles, externalrole, provider_id } = this.getRoles(contentData);
        this.setState({
            roles,
            externalrole,
            provider_id,
        });
    }

    getRoles(contentData) {
        const {
            group: {
                common: { extendedcommon: { roles: { role: roleArray = [] } = {} } = {} } = {},
                universal_id = null,
                external = null,
            } = {},
        } = contentData;
        const { externalrole, provider_id } = resolveContentTalent(
            universal_id,
            external,
            this.handleTalentClick
        );
        return { externalrole, roles: roleArray, provider_id };
    }

    changeContent(groupId) {
        const { data } = this.state;
        if (groupId !== this.groupId) {
            this.props.history.replace(`/vcard/${groupId}/1`);
        }
    }

    pushContent(groupId) {
        if (groupId !== this.groupId) {
            const { history } = this.props;
            history.push(`/vcard/${groupId}`);
        }
    }

    async loadContent(groupId, ignoreSeenLast = false) {
        const { from } = store.getState().navbar;
        const dataRibbon = this.state.data;
        const title = from.ribbon_title;
        if (title && dataRibbon) {
            Utils.sendMetric(
                this.props,
                title.toLowerCase(),
                dataRibbon.title.toLowerCase(),
                CARRUCEL_VCARD
            );
        }
        console.log('[VCard] loadContent groupId', groupId, 'ignoreSeenLast', ignoreSeenLast);
        if (!isValidGroupId(groupId)) return;
        this.groupId = groupId;
        this.clearPBIandRecommendations();
        const contentData = await getContentData(groupId);

        const { group: {
          common: {
            publicity = 'false',
            rolls = {}
          } = {}
        } = {}
        } = contentData || {};

        store.dispatch(
          setContentDataPublicity({
            publicity,
            rolls,
            currentContentType: AAF_CONTENT_IS_VOD,
          })
        );

        if (!contentData) {
            this.lenguageData = [];
            return;
        }
        this.setLenguageData(contentData);
        const seasonId = getSeasonId(contentData);
        const isSerie = !!seasonId;
        let bookmark, favorited;

        const data = parseContentData(contentData);
        this.loadPurchaseButtonInfoAsync(groupId, data, title);
        this.updateResume(data);
        if (isSerie) {
            this.changeRibbonOrder(isSerie);
            this.asyncLoadSerieContent(contentData);
        }
        this.loadRecommendationsAsync(groupId, contentData);
        this.loadTalents(contentData);

        if (!isAnonymousFromProps(this.props)) {
            if (isSerie && !ignoreSeenLast) {
                const seenLast = await UserSeenLast(groupId);
                const groupIdToRedirect = getGroupIdToRedirect(seenLast);
                if (groupIdToRedirect && groupIdToRedirect !== groupId) {
                    console.log('[VCard] lets change content: ', groupIdToRedirect);
                    return this.changeContent(groupIdToRedirect);
                }
            }
            this.loadBookMarkAndFavoritedAsync(groupId);
        }
    }

    changeRibbonOrder(isSerie = false) {
        const { ribbonOrder: currentOrder } = this.state;
        if (isSerie) {
            [currentOrder[0], currentOrder[1]] = [currentOrder[1], currentOrder[0]]; // swap the ribbon order;
            this.setState({ ribbonOrder: currentOrder });
        }
    }

    focusOnElementoPredeterminado = (selector = '.elementopredeterminado') => {
        if (Utils.isModalHide()) {
            //window.SpatialNavigation.focus(selector);
          Utils.setInitialFocusChangeTime(selector, 0);
        }
    };

    updateResume(data) {
        const { title, types, genders = [] } = data;
        this.sendVirtualPage(types, genders, title);
        this.setState({ data, isLoading: false });
    }

    getButtonFavRender = (isFavoriteBtn) => {
        let text_mi_lista = null;
        let text = null;
        if (isFavoriteBtn) {
            text = Translator.get(
                'vcard_access_option_button_deleteFavoritiesList_text1',
                'Quitar de'
            );
            text_mi_lista = Translator.get(
                'vcard_access_option_button_deleteFavoritiesList_text2',
                'Mi lista'
            );
        } else {
            text = Translator.get(
                'vcard_access_option_button_addFavoritiesList_text1',
                'Agregar a'
            );
            text_mi_lista = Translator.get(
                'vcard_access_option_button_addFavoritiesList_text2',
                'Mi lista'
            );
        }

        return (
            <div>
                {text}
                <br />
                {text_mi_lista}
            </div>
        );
    };

    getButtons(data, pbi) {
        let addonDescription = '';
        let isAddonDescriptionGenerated = false;
        const buttons = [];
        const {
            hasTrailer = false,
            isSerie = false,
            isFavorite = false,
            providerName = '',
        } = data || {};

        const {
            playButton: { visible = '0' } = {},
            listButtons: { button: purchaseButtons = [] } = {},
        } = pbi || {};
        const canPlay = visible === '1';

        const playBtn = {
            iconClassName: 'canPlay',
            icon: Asset.get('vcard_access_option_button_play', '/images/Reproducir.png'),
            text: Translator.get('vcard_access_option_button_play', 'Reproducir'),
            onClick: this.handlePlayClick,
            type: 'image',
        };
        const trailerBtn = {
            icon: Asset.get('vcard_access_option_button_trailer', '/images/Trailer.png'),
            text: Translator.get('vcard_access_option_button_trailer', 'Ver trailer'),
            onClick: this.handleTrailerClick,
            type: 'image',
        };
        const seasonBtn = {
            icon: Asset.get('vcard_access_option_button_selectSeason', '/images/Temporadas.png'),
            text: Translator.get(
                'vcard_access_option_button_selectSeason',
                'Seleccionar temporada'
            ),
            onClick: this.handleSelectSeason,
            type: 'image',
        };
        const favoriteBtn = {
            id: 'vcard-fav-button',
            icon: Asset.get('vcard_access_option_button_addList', '/images/Mas.png'),
            text: this.getButtonFavRender(false),
            onClick: this.handleFavoriteClick,
            type: 'image',
        };
        const unfavoriteBtn = {
            id: 'vcard-fav-button',
            icon: Asset.get('vcard_access_option_button_deleteList', '/images/menos.png'),
            text: this.getButtonFavRender(true),
            onClick: this.handleUnFavoriteClick,
            type: 'image',
        };
        if (canPlay) {
            buttons.push(playBtn);
        } else {
            const getButtonStyle = (btn) => {
                const key = `${btn.producttype}_wp${btn.waspurchased}`;
                const buttonColors =
                    Utils.getApaMetadataKey('purchasebutton_colors', {}, key) ||
                    Utils.getApaMetadataKey('purchasebutton_colors', {}, 'default');
                let style = {};

                if (buttonColors) {
                    if (buttonColors.gradient) {
                        let directionWebkit = '';
                        switch (buttonColors.gradient.direction) {
                            case 'to left':
                                directionWebkit = 'right';
                                break;
                            case 'to right':
                            default:
                                directionWebkit = 'left';
                                break;
                        }
                        style = {
                            background: `-webkit-linear-gradient(${directionWebkit}, ${buttonColors.gradient.color_stop1}, ${buttonColors.gradient.color_stop2})`,
                            'background-image': `linear-gradient(${buttonColors.gradient.direction}, ${buttonColors.gradient.color_stop1}, ${buttonColors.gradient.color_stop2})`,
                        };
                    } else if (buttonColors.background) {
                        style.background = `${buttonColors.background}`;
                    }
                }
                return style;
            };

            purchaseButtons.forEach((listButton, index) => {
                const {
                    bonus,
                    oneoffertype,
                    producttype,
                    price,
                    currency,
                    periodicity,
                    family,
                    purchasable,
                    oneofferdesckey,
                    frequency,
                    linkworkflowstart
                } = listButton;
                const taxLabel = `${currency}${price}` !== '' ? Translator.get(`${producttype}_subscriptionDescription_costTaxIncluded_label`, '') : '';
                const textButton = this.getTransactionTypeLabel({oneoffertype: oneoffertype, producttype: producttype, label: Translator.get(oneofferdesckey, ''), frequency: frequency});
                let iconLabel = `${currency}${price}` !== '' ? `${currency}${price}` : Translator.get('offer_button_title_subscription_promogate');
                let isPromoCode = `${currency}${price}` === '' && Translator.get('offer_button_title_subscription_promogate').includes('Promocional');
                let showPromogate = false;
                let iconClassName = 'purchase';

                if ((currency === '' && price === '')) {
                    if (isPromoCode && linkworkflowstart.includes(PROMOGATE)) {
                        showPromogate = true;
                    } else if (!linkworkflowstart.includes(PROMOGATE)) {
                        isPromoCode = false;
                        iconLabel = Translator.get(`${bonus}_free_period`, '');
                    }
                }

                if (oneoffertype === PBI_OFFER_SUBSCRIPTION_TYPE) {
                    if (!isAddonDescriptionGenerated) {
                        if (producttype === 'CV_MENSUAL' || producttype === 'CV_ANUAL') {
                            isAddonDescriptionGenerated = true;
                        }
                        const { from } = store.getState().navbar;
                        const watchWithBtn = {
                            style: { backgroundColor: getWatchWithBtnBGColor(family) },
                            icon: 'watch-with',
                            family,
                            text: Translator.get(
                                `${family}_access_title_button_subscriptionDescription`,
                                `Ver con ${providerName}`
                            ),
                            iconClassName: 'watch-with',
                            className: 'large',
                            onClick: (e) => {
                                if (from && from.ribbon_title && from.ribbon_title !== '') {
                                    sendGAEvent({
                                        hitType: 'event',
                                        eventCategory: decodeHTML5(
                                            NODE_RIBBONS.replace('{{NODE_NAME}}', from.ribbon_title)
                                        ),
                                        eventAction: decodeHTML5(from.card_element.title),
                                        eventLabel: decodeHTML5(
                                            PLAN_SELECTED_WHAT_INCLUDED.replace(
                                                '{{PLAN_SELECTED}}',
                                                providerName
                                            )
                                        ),
                                    });
                                }
                                this.handleWathWithDetailsClick(e, family);
                            },
                            type: 'watch-with',
                        };
                        buttons.push(watchWithBtn);
                    }
                    iconClassName = PBI_OFFER_SUBSCRIPTION_TYPE;
                }
                if ((purchasable && showPromogate) || (purchasable && !isPromoCode)) {
                    const updateListButton = { ...listButton, isPromoCode };
                    buttons.push({
                        text: textButton,
                        icon: iconLabel,
                        taxes: taxLabel,
                        isPromoCode,
                        iconClassName,
                        style: getButtonStyle(listButton),
                        onClick: (e) => this.handlePurchaseClick(e, updateListButton, providerName),
                        type: 'text',
                    });
                }
                if (oneoffertype === PBI_OFFER_SUBSCRIPTION_TYPE && index === 0) {
                    addonDescription = this.generateAddonDescription({
                        family,
                        bonus,
                        providerName,
                        price,
                        currency,
                        periodicity,
                        producttype,
                        purchasable,
                    });
                }
            });
        }
        if (isSerie) {
            buttons.push(seasonBtn);
        }
        if (hasTrailer) {
            buttons.push(trailerBtn);
        }
        const addFavoriteButton = () => {
            if (isFavorite) {
                buttons.push(unfavoriteBtn);
            } else {
                buttons.push(favoriteBtn);
            }
        }
        if (AAF.AdsUtils.isAdsEnable()) {
            const userType = AAF.AdsUtils.getUserType();
            const isFreemium = AAF.AdsUtils.isUserFreemium(userType);
            if (!isFreemium) {
                addFavoriteButton();
            } else {
                buttons.push(favoriteBtn);
            }
        } else {
            if (!isAnonymousFromProps(this.props)) {
                addFavoriteButton();
            }
        }
        if (buttons[0]) {
            buttons[0].elementopredeterminado = true;
        }
        return {
            buttons,
            addonDescription,
        };
    }

    getNotification() {
        return this.getAddonAndroidMessage(getAndroidTvPolicesLabels());
    }

    generateAddonDescription({
        family,
        bonus,
        providerName,
        price,
        currency,
        periodicity,
        producttype,
        purchasable,
    }) {
        if (!purchasable) {
            return null;
        }
        let translatedPeriodicity;
        switch (periodicity) {
            case 'month':
            default:
                translatedPeriodicity = 'mes';
        }
        const prefix = Translator.get(`transactional_${bonus}_subscription_vcard_description`, '');


        const vcardPrice = getTransactionalPrice({
            component : TRANSACTION_COMPONENT_VCARD,
            currency,
            price,
            periodicity,
            producttype
        });

        const vcardTax = getTransactionalTax({
            component : TRANSACTION_COMPONENT_VCARD,
            currency,
            price,
            periodicity,
            producttype
        });
        const vcardBonus = getTransactionalBonus({
            component : TRANSACTION_COMPONENT_VCARD,
            bonus,
            producttype,
            family
        });

        const metadataPriceTax = {}, metadataBonus = {};

        if (shouldMetadataInfoShowed()){
            metadataPriceTax['data-metadata-key'] = `${vcardPrice.key},${vcardTax.key}`;
            metadataBonus['data-metadata-key'] = `${vcardBonus.key}`;
       }

        return (
            <div className={`${VCARD_RESUMEN_MAIN_CLASSNAME}-addon-description`}>
                <span className="bold" {...metadataPriceTax}>
                    {`${Translator.get(
                        `${family}_access_commercialInfo_label`,
                        `Contenido incluido con ${providerName} por`
                    )} ${vcardPrice.label?`${vcardPrice.label} ${vcardTax.label}`:''}`}
                    {' '}
                </span>
                {bonus && (
                    <span {...metadataBonus} className="bold aaf_app_detail_selector-text-blue">{`${vcardBonus.label}`}</span>
                )}
            </div>
        );
    }

    getAddonAndroidMessage(labels) {
        const classes = {
            classNameContainer: `${VCARD_RESUMEN_MAIN_CLASSNAME}-addon-android-tv-policies`,
            classNameTitle: 'title-android-tv',
            classNameDescription: 'description-android-tv',
        };

        return getAddonAndroidMessageClassNames(labels, classes);
    }

    shouldShowAndroidMessage() {
        const { pbi = {} } = this.state || {};
        const { listButtons: { button = [] } = {} } = pbi || {};
        return UtilsPagos.shouldShowAndroidMessage(button);
    }

    /* Ciclo de vida del componente */

    componentDidMount() {
      getLastTouch("seen").then(lastTouchSeen => {
        this.setState({ lastTouchSeen });
      })
        this.addListener();
        this.loadContent(
            getGroupIdFromMatchParams(this.props),
            getIgnoreSeenLastFromMatchParams(this.props)
        );
    }

    componentWillUnmount() {
        removeDynamicFocus()
        this.removeListener();
        this.cleanDataEpisodes();
    }

    componentWillReceiveProps(nextProps) {
        removeDynamicFocus()
        const currentGroupId = getGroupIdFromMatchParams(this.props);
        const nextGroupId = getGroupIdFromMatchParams(nextProps);
        const nextIgnoreSeenLast = !!getIgnoreSeenLastFromMatchParams(nextProps);
        if (currentGroupId !== nextGroupId) {
            this.loadContent(nextGroupId, nextIgnoreSeenLast);
        }
        this.cleanDataEpisodes();
    }

    getTransactionTypeLabel({oneoffertype, producttype, label, frequency}) {
        let transactionType = 0;
        if (oneoffertype.toLowerCase().includes('buy')) {
            if (producttype.toLowerCase().includes('season')) {
                transactionType = TransactionDetailType.BUY_SEASON;
            } else if (producttype.toLowerCase().includes('episode')) {
                transactionType = TransactionDetailType.BUY_EPISODE;
            } else {
                transactionType = TransactionDetailType.BUY_MOVIE;
            }
        } else if (oneoffertype.toLowerCase().includes('rent')) {
            transactionType = TransactionDetailType.RENT_MOVIE;
        }
        else if (oneoffertype.toLowerCase().includes('subscrition')) {
            transactionType = TransactionDetailType.SUSCRIPTION;
        }
        else {
            throw new Error('[AAF Payment] Tipo de transaccion no asociado');
        }
        switch(transactionType) {
            case TransactionDetailType.RENT_MOVIE:
                label = label.replace('@frequency ', frequency);
                return label;
            default:
                return label;
        }
    }

    handleScroll(event) {
        removeDynamicFocus();
    }

    render() {
        const {
            isLoading,
            data,
            pbi,
            recommendations,
            serieData,
            roles,
            externalrole,
            ribbonOrder,
            dataEpisodes,
          lastTouchSeen
        } = this.state;
        const { buttons, addonDescription } = this.getButtons(data, pbi);
        const { setMetricsEvent = () => {}, user } = this.props;
        const notification = this.shouldShowAndroidMessage() ? this.getNotification() : null;
        return (
            <div className={VCARD_CONTAINER_CLASSNAME}>
                <div className={VCARD_MAIN_CLASSNAME} onPointerMove={this.handleScroll}  onWheel={this.handleScroll}>
                    <VCardDetails
                        data={data}
                        buttons={buttons}
                        addonDescription={addonDescription}
                        isLoading={isLoading}
                        dataEpisodes={dataEpisodes}
                        notification={notification}
                        setMetricsEvent={setMetricsEvent}
                    />
                    <VCardEpisodes
                        serieData={serieData}
                        setMetricsEvent={setMetricsEvent}
                        title={data && data.title}
                        handleEpisodeClick={this.handleEpisodeClick}
                        onHandleFocusEpisodes={this.handleFocusEpisodes}
                        lastTouchSeen={lastTouchSeen}
                    />
                    {ribbonOrder &&
                        ribbonOrder.find((_ribbon) => _ribbon === RECOMMENDATION_RIBBON) && (
                            <VCardRecommendations
                                key={new Date().getTime() + 1}
                                onRecommendationClick={this.pushContent}
                                recommendations={recommendations}
                                setMetricsEvent={setMetricsEvent}
                                user={user}
                                isLoading={isLoading}
                            />
                        )}
                    {ribbonOrder && ribbonOrder.find((_ribbon) => _ribbon === TALENT_RIBBON) && (
                        <VCardTalents
                            content_name={data && data.title}
                            key={new Date().getTime()}
                            roles={roles}
                            externalrole={externalrole}
                            setMetricsEvent={setMetricsEvent}
                            handleTalentClick={this.handleTalentClick}
                            user={user}
                        />
                    )}
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = {
    setMetricsEvent,
    playFullMedia,
    showNotification,
    showModal,
    setLastTouchSeen,
    setLastTouchFavorited,
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps, mapDispatchToProps)(VCard);



// WEBPACK FOOTER //
// ./src/components/Ficha/VCard.jsx